import React from "react"
import { Badge } from "reactstrap"
import { SortIcon } from "components/Table_SortColumnIcon"

const visitorsListColumn = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, visitor) => <>{visitor.id}</>,
    },
    {
      text: "Visitor Name",
      dataField: "name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, visitor) => <>{visitor?.name}</>,
    },
    {
      text: "Visitor Email",
      dataField: "email",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, visitor) => <>{visitor?.email}</>,
    },
    {
      text: "Arrival Date",
      dataField: "arrival_date",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, visitor) => (
        <>{visitor?.arrival_date ? visitor?.arrival_date?.split(" ")[0] : ""}</>
      ),
    },
    {
      text: "Arrival Time",
      dataField: "arrival_dateTime",
      formatter: (cellContent, visitor) => (
        <>{visitor?.arrival_date ? visitor?.arrival_date?.split(" ")[1] : ""}</>
      ),
    },
    {
      text: "Departure Time",
      dataField: "departure_date",
      formatter: (cellContent, visitor) => (
        <>
          {visitor?.departure_date
            ? visitor?.departure_date?.split(" ")[1]
            : ""}
        </>
      ),
    },
    {
      text: "Invited By",
      dataField: "tenant",
      formatter: (cellContent, visitor) => (
        <>
          {visitor?.tenant && visitor?.tenant?.display_name
            ? visitor?.tenant?.display_name
            : ""}
        </>
      ),
    },
    {
      text: "User's Tags",
      dataField: "tags",
      formatter: (cellContent, visitor) => (
        <>
          {visitor?.tenant_tags?.map((tag, index) => (
            <div key={index}>
              <Badge
                className={"font-size-10 badge-soft-" + "primary"}
                color={"primary"}
                pill
              >
                {tag.tag}{" "}
              </Badge>
            </div>
          ))}
        </>
      ),
    },
    {
      text: "Date Registered",
      dataField: "created_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, visitor) => <>{visitor?.created_at}</>,
    },
  ]
}

export default visitorsListColumn
